import React, { useState } from 'react';
import '../../App.css';
import '../../scss/App.scss';
import '../../scss/Hotel.scss';
import { Box, Container, Grid, Form  } from '@mui/material';


function HotelPayment() {
const [selectedCard, setSelectedCard] = useState('visa');
const [selectedOption, setSelectedOption] = useState('full');
  return (
    <>


      
      <Container maxWidth="md" className="deals-header py-4 ">

        <Grid container spacing={2} justifyContent="center" >
        <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>

          <div className="container hotel-header px-0">
      <div className="row align-items-center g-3">
        
        {/* Left column */}
        <div className="col-lg-12 col-md-12 col-sm-12">
         <nav aria-label="breadcrumb" className="breadcrumb-wrapper mb-2">
      <ol className="breadcrumb mb-0">
        <li className="breadcrumb-item">
          <a href="#" className="text-decoration-none text-dark">India</a>
        </li>
        <li className="breadcrumb-item">
          <a href="#" className="text-decoration-none text-dark">Varanasi</a>
        </li>
        <li className="breadcrumb-item active" aria-current="page">
          Hotel Janki
        </li>
      </ol>
    </nav>
        
          
        </div>

      </div>
    </div>
        </Grid>
        <Grid size={{ xl: 8, lg: 8, md: 8, sm: 12, xs: 12 }}>
          <div className="card room-summary-card p-4 shadow-sm">
      {/* Room Title and Price */}
      <div className="d-flex justify-content-between align-items-start">
        <h5 className="room-title mb-0">
          Superior room – 1 double bed or 2 twin beds
        </h5>
        <div className="room-price text-end">
          ₹2800 <span className="unit">/night</span>
        </div>
      </div>

      {/* Hotel Info */}
      <div className="card hotel-info-card border mt-3 p-2">
        <div className="d-flex align-items-center">
          <img
            src="/assets/hotel/hotel-card/hotel-card1.svg"
            alt="Hotel"
            className="hotel-thumbnail me-2"
          />
          <div>
            <h6 className="hotel-name mb-1">Hotel Janki International</h6>
            <p className="hotel-address text-muted mb-0 small">
              <i className="bi bi-geo-alt-fill me-1"></i>
              D-59/105-7, Chandrika Nagar Colony, Sigra, Varanasi, Uttar Pradesh 221001
            </p>
          </div>
        </div>
      </div>

      {/* Check-in / Check-out */}
      <div className="d-flex justify-content-between align-items-center text-center mt-4 check-dates">
        <div>
          <p className="mb-0 fw-semibold">Thursday, Sep 21</p>
          <small className="text-muted">Check-In</small>
        </div>
        <div className="check-icon mx-2">
          <i className="bi bi-building display-6"></i>
        </div>
        <div>
          <p className="mb-0 fw-semibold">Friday, Sep 24</p>
          <small className="text-muted">Check-Out</small>
        </div>
      </div>
    </div>


    <div className="card payment-options p-3 mt-3">
      {/* Pay in full */}
      <div
        className={`payment-option px-3 py-3 mb-2 rounded ${
          selectedOption === 'full' ? 'selected' : ''
        }`}
        onClick={() => setSelectedOption('full')}
      >
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <div className="fw-semibold title">Pay in full</div>
            <div className="desc">Pay the total and you are all set</div>
          </div>
          <div className="radio-circle">
            <input
              type="radio"
              name="payment"
              checked={selectedOption === 'full'}
              readOnly
            />
          </div>
        </div>
      </div>

      {/* Pay part now, part later */}
      <div
        className={`payment-option px-3 py-3 rounded ${
          selectedOption === 'split' ? 'selected' : ''
        }`}
        onClick={() => setSelectedOption('split')}
      >
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <div className="fw-semibold title">Pay part now, part later</div>
            <div className="desc text-muted">
              Pay ₹2800 now, and the rest (₹5600) will be automatically charged
              to the same payment method on Sep 21, 2025. No extra fees.
              <div className="mt-1 more-info">More info</div>
            </div>
          </div>
          <div className="radio-circle">
            <input
              type="radio"
              name="payment"
              checked={selectedOption === 'split'}
              readOnly
            />
          </div>
        </div>
      </div>
    </div>

     <div className="card-selector card p-3 mt-3">
      {/* Saved Card */}
      <div
        className={`saved-card d-flex justify-content-between align-items-center p-3 rounded ${
          selectedCard === 'visa' ? 'selected' : ''
        }`}
        onClick={() => setSelectedCard('visa')}
      >
        <div className="d-flex align-items-center gap-3">
          <span className="card-type badge bg-white text-dark">VISA</span>
          <span className="card-number text-white fw-bold">•••• 4321</span>
          <span className="text-white">02/27</span>
        </div>
        <input
          type="radio"
          name="card"
          checked={selectedCard === 'visa'}
          readOnly
        />
      </div>

      {/* Add New Card */}
      <div
        className="add-card mt-3 text-center p-4 border border-2 border-dashed rounded"
        onClick={() => alert('Add card modal')}
      >
        <div className="plus-circle mb-2">+</div>
        <div className="text-muted">Add a new card</div>
      </div>
    </div>
        </Grid>
        <Grid size={{ xl: 4, lg: 4, md: 4, sm: 12, xs: 12 }}>

          <div className="paymentSidebar shadow-sm p-3 bg-white rounded">
      {/* Hotel Info */}
      <div className="d-flex align-items-start gap-3 mb-3">
        <img
          src="assets/hotel/hotel-card/hotel-card1.svg"
          alt="Hotel"
          className="rounded"
          width="80"
          height="80"
        />
        <div>
          <div className="text-muted small">CVK Park Bosphorus...</div>
          <div className="fw-semibold">Superior room – 1 double bed or 2 twin beds</div>
          <div className="d-flex align-items-center gap-2 mt-1">
            <span className="badge bg-light text-success fw-bold">4.2</span>
            <small className="text-muted">
              <strong className="text-dark">Very Good</strong> 54 reviews
            </small>
          </div>
        </div>
      </div>

      <hr />

      {/* Refundable Info */}
      <div className="text-muted small mb-3">
        Fully refundable before <strong>Thu, 15 Sep</strong>
      </div>

      <hr />

      {/* Price Details */}
      <div className="mb-3">
        <div className="fw-semibold mb-2">Price Details</div>
        <div className="d-flex justify-content-between">
          <span>Base Fare</span>
          <span>₹2500</span>
        </div>
        <div className="d-flex justify-content-between">
          <span>Discount</span>
          <span>₹0</span>
        </div>
        <div className="d-flex justify-content-between">
          <span>Taxes</span>
          <span>₹400</span>
        </div>
        <div className="d-flex justify-content-between">
          <span>Service Fee</span>
          <span>₹100</span>
        </div>
        <hr />
        <div className="d-flex justify-content-between fw-semibold">
          <span>Total</span>
          <span>₹2800</span>
        </div>
      </div>

      {/* Button */}
      <button className="btn btn-teal w-100">Pay Now</button>
    </div>
        </Grid>
        </Grid>
      </Container>




    </>
  );
}
export default HotelPayment;